import { Component } from "react"
import PropTypes from "prop-types"
import { useDropzone } from "react-dropzone"
import displayFlash from "partners/scripts/display_flash"
import fetchAuthenticityToken from "app/scripts/refresh_form_authenticity_token"
import classNames from "classnames"

export default class ImageUploader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentImage: this.props.current_image,
    }
  }

  onDrop = async file => {
    displayFlash("Uploading service icon…")

    fetch(
      new Request(`/services/${this.props.service_slug}/icon`, {
        method: "POST",
        cache: "no-store",
        body: file[0],
        headers: {
          "X-CSRF-Token": await fetchAuthenticityToken(),
        },
      })
    )
      .then(async response => {
        if (!response.ok) {
          if (response.status === 413) {
            throw new Error("The image is too large.")
          } else if (response.status === 422) {
            let errorResponse = await response.json()
            throw new Error(errorResponse.message)
          } else throw new Error()
        } else {
          readURL(file, "div[data-image-type=monochrome] img", this.props.preview_target)
          displayFlash("Service icon saved successfully")
        }
      })
      .catch(error => {
        displayFlash(error || "There has been an error. Please try again!", "alert-warning")
      })
  }

  setStyle() {
    if (this.props.brand_color) {
      return {
        backgroundColor: `#${this.props.brand_color}`,
        borderColor: `#${this.props.brand_color}`,
      }
    } else {
      return {}
    }
  }

  renderImageAndUploadButton() {
    return (
      <div className="content">
        {this.state.currentImage && (
          <div className="button">
            <img src={this.state.currentImage} width="310" />
          </div>
        )}
        <p className="note">
          <span
            className={classNames("button-tertiary", "button-on-color")}
          >
            Upload a new file
          </span>
        </p>
      </div>
    )
  }

  render() {
    return (
      <DropzoneWrapper
        onDrop={this.onDrop}
        className="dropzone monochrome"
        style={this.setStyle()}
        renderContent={this.renderImageAndUploadButton()}
      />
    )
  }
}

function DropzoneWrapper({ onDrop, className, style, renderContent }) {
  const { getRootProps, getInputProps } = useDropzone({ onDrop })

  return (
    <div {...getRootProps({ className, style })}>
      <input {...getInputProps()} />
      {renderContent}
    </div>
  )
}

function readURL(input, target, previewTarget) {
  if (input[0]) {
    const reader = new FileReader()
    reader.onload = e => {
      document.querySelector(target).src = e.target.result
      if (previewTarget.length) {
        document.querySelectorAll(previewTarget).forEach(preview => (preview.src = e.target.result))
      }
    }

    reader.readAsDataURL(input[0])
  }
}

ImageUploader.propTypes = {
  current_image: PropTypes.string,
  color_style: PropTypes.string,
  service_slug: PropTypes.string.isRequired,
  authenticity_token: PropTypes.string.isRequired,
  brand_color: PropTypes.string,
  dimensions_message: PropTypes.string,
  preview_target: PropTypes.array,
  field: PropTypes.string,
}

ImageUploader.defaultProps = {
  preview_target: [],
}
